<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.name'/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue